$('.favorites').tabs({
	afterChangeTab: function() {
        Linksoft.MujKosmas.FavoritesCheckAfterTabChange();
        /* todo remove setTimeout() */
        setTimeout(()=> {
            Linksoft.MujKosmas.InitializeDragAndDrop();
		},1000);
	}
});